<template>
  <div class="row full-width q-my-md">
    <div
      class="row col-12 q-col-gutter-md"
    >
      <div
        v-for="sessionNoteField in sessionNoteFields"
        :key="sessionNoteField.id"
        class="col session-note-field"
      >
        <session-note-field-form
          :session-note-field="sessionNoteField"
          :grouped-session-note-fields="sessionNoteFields"
          :session="session"
          :session-activity="sessionActivity"
          :linked-appointment="linkedAppointment"
          :disabled-fields="disabledFields"
          inline-label
          @input="onInputValue($event, sessionNoteField)"
          @select-option="onSelectOption($event, sessionNoteField)"
          @select-single-option="onSelectSingleOption($event, sessionNoteField)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import SessionNoteFieldForm from 'components/Sessions/SessionNoteTemplates/SessionNoteFieldForm';
import { Timestamp } from 'firebase/firestore';

export default {
  name: 'SessionNoteFieldGroupForm',

  components: { SessionNoteFieldForm },

  props: {
    sessionNoteFields: {
      type: Array,
      required: true,
    },
    session: {
      type: Object,
      default: null,
    },
    sessionActivity: {
      type: Object,
      required: true,
    },
    linkedAppointment: {
      type: Object,
      default: null,
    },
    disabledFields: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['input', 'select-option', 'select-single-option'],

  methods: {

    onInputValue(value, sessionNoteField) {
      this.$emit('input', value, sessionNoteField);

      if (typeof sessionNoteField.adjustGroupField === 'function') {
        const adjustResult = sessionNoteField.adjustGroupField(value, this.sessionNoteFields);
        if (!adjustResult) {
          return;
        }

        const { adjustedField, changedValue } = adjustResult;
        if (adjustedField && changedValue) {
          this.$emit(
            'input',
            changedValue instanceof Timestamp
              ? changedValue.toDate()
              : null,
            adjustedField,
          );
        }
      }
    },

    onSelectOption(selectedOptions, sessionNoteField) {
      this.$emit('select-option', selectedOptions, sessionNoteField);
    }, // onSelectOption()

    onSelectSingleOption(value, sessionNoteField) {
      this.$emit('select-single-option', value, sessionNoteField);
    }, // onSelectSingleOption()

  },
};
</script>

<style lang="scss" scoped>
.session-note-field {
  min-width: 180px;
}
</style>
